import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { AlignmentPanel } from 'wix-rich-content-toolbars-ui';
import { DividerAlignmentButton } from './toolbar/buttons/DividerAlignmentButton.js';
import { DividerSizeButton } from './toolbar/buttons/DividerSizeButton.js';
import { DividerStyleButton } from './toolbar/buttons/DividerStyleButton.js';
import { TIPTAP_DIVIDER_TYPE } from 'ricos-content';
import { DIVIDER_BUTTONS, DIVIDER_STYLE_BUTTON_DATA_HOOK, DIVIDER_SIZE_BUTTON_DATA_HOOK, DIVIDER_ALIGNMENT_BUTTON_DATA_HOOK, DIVIDER_STYLE_RESOLVER_ID, DIVIDER_SIZE_RESOLVER_ID } from './const.js';
import LineStylePanel from './toolbar/modals/LineStylePanel.js';
import DividerSizePanel from './toolbar/modals/DividerSizePanel.js';
import { selectedNodeResolver, getVisibleOnlyOnDesktopResolver } from 'wix-rich-content-plugin-commons';
import { DividerData_Width, DividerData_Alignment } from 'ricos-schema';
import 'ricos-context';
import './toolbar/buttons/dividerButtonsData.js';
import './icons/SingleLineStyle.js';
import './icons/DoubleLineStyle.js';
import './icons/DashedLineStyle.js';
import './icons/DottedLineStyle.js';
import 'ricos-types';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const resolveDividerAttribute = ({
  resolverId,
  attribute
}) => {
  return {
    id: resolverId,
    resolve: (content) => {
      var _a, _b;
      if (Array.isArray(content) && content.length > 0) {
        return (_b = (_a = content.find((node) => node.type.name === TIPTAP_DIVIDER_TYPE)) == null ? void 0 : _a.attrs) == null ? void 0 : _b[attribute];
      } else {
        return void 0;
      }
    }
  };
};
const getToolbarButtons = (config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: DIVIDER_BUTTONS.style,
      dataHook: DIVIDER_STYLE_BUTTON_DATA_HOOK,
      command: ({ value, editorCommands }) => {
        editorCommands.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, {
          lineStyle: value
        }).run();
      },
      modal: {
        Component: LineStylePanel,
        id: DIVIDER_BUTTONS.style
      },
      attributes: {
        nodeStyle: resolveDividerAttribute({
          resolverId: DIVIDER_STYLE_RESOLVER_ID,
          attribute: "lineStyle"
        })
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DividerStyleButton, { toolbarItem, id: DIVIDER_BUTTONS.style })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: DIVIDER_BUTTONS.size,
      dataHook: DIVIDER_SIZE_BUTTON_DATA_HOOK,
      command: ({ value, editorCommands, attributes: { selectedNode } }) => {
        var _a;
        const nodeContainerData = (_a = selectedNode.attrs) == null ? void 0 : _a.containerData;
        const isFullWidth = value === DividerData_Width.LARGE;
        const newAttributes = isFullWidth ? {
          width: value,
          alignment: DividerData_Alignment.CENTER,
          containerData: __spreadProps(__spreadValues({}, nodeContainerData), { alignment: DividerData_Alignment.CENTER })
        } : { width: value };
        editorCommands.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, newAttributes).run();
      },
      modal: {
        Component: DividerSizePanel,
        id: DIVIDER_BUTTONS.size
      },
      attributes: {
        nodeSize: resolveDividerAttribute({
          resolverId: DIVIDER_SIZE_RESOLVER_ID,
          attribute: "width"
        }),
        selectedNode: selectedNodeResolver,
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DividerSizeButton, { toolbarItem, id: DIVIDER_BUTTONS.size })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: DIVIDER_BUTTONS.alignment,
      dataHook: DIVIDER_ALIGNMENT_BUTTON_DATA_HOOK,
      command: ({ value, editorCommands, attributes: { selectedNode } }) => {
        var _a;
        const nodeContainerData = (_a = selectedNode.attrs) == null ? void 0 : _a.containerData;
        editorCommands.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, {
          alignment: value,
          containerData: __spreadProps(__spreadValues({}, nodeContainerData), { alignment: value })
        }).run();
      },
      modal: {
        Component: decorateComponentWithProps(AlignmentPanel, {
          options: ["LEFT", "CENTER", "RIGHT"]
        }),
        id: DIVIDER_BUTTONS.alignment
      },
      attributes: {
        selectedNode: selectedNodeResolver,
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DividerAlignmentButton, { id: DIVIDER_BUTTONS.alignment, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
